module.exports = __webpack_public_path__ + "static/sang-aa34302a5c473b466c3dce3a126cfa85.png";